import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AuthService } from './../../../../services/auth.service';
import { CollaboratorService } from './../../../../rest/api/collaborator.service';
import { HelperService } from './../../../../services/helper.service';
import { MemberService } from './../../../../rest/api/member.service';

import * as _ from 'lodash';

@Component({
  selector: 'app-role',
  templateUrl: './role.component.html',
  styleUrls: ['./role.component.scss']
})
export class RoleComponent implements OnInit {
  @Output() collaboratorAccessSpaceEmit = new EventEmitter();
  @Output() inviteCollaboratorEmit = new EventEmitter();
  @Output() deleteCollaboratorEmit = new EventEmitter();
  @Output() reactivateCollaboratorEmit = new EventEmitter();

  accessToken: any;
  collaboratorsData: any;
  filteredCollaboratorsData: any;
  pendingCollaborators: any;
  activeCollaborators: any;
  deletedCollaborators: any;
  spaceListData: any;
  itemsPerPage = 5;
  collaboratorLoader = true;
  successMsg: string;
  errorMsg: string;
  isSubmitted = false;
  selectedCollaborator: any;
  errors = [];

  statusDesc = false;
  roleDesc = false;

  selectedStatus = '';
  selectedRole = '';

  constructor(
    private authService: AuthService,
    public helperService: HelperService,
    public collaboratorService: CollaboratorService,
    public memberService: MemberService,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
    this.getCollaboratorList();
    this.getSpaceList(1, this.itemsPerPage, '', '');
  }

  getCollaboratorList() {
    this.collaboratorService.getCollaboratorList(this.accessToken).subscribe((response: any) => {
      this.collaboratorsData = response && response.data ? response.data : [];
      this.filteredCollaboratorsData = this.collaboratorsData ? this.collaboratorsData : [];
      this.collaboratorLoader = false;
    }, err => {
      this.collaboratorsData = [];
      this.filteredCollaboratorsData = [];
      this.collaboratorLoader = false;
    });
  }

  getSpaceList(page, limit, categoryId, keywords) {
    const thisobject = this;
    this.memberService.getMemberSpace({
      Authorization: this.accessToken,
      page: page,
      paginate: limit,
      categoryId: categoryId || undefined,
      keywords: keywords || undefined,
      status: ''
    }).subscribe((response: any) => {
      thisobject.spaceListData = response && response.data ? response.data : [];
    }, err => {
      thisobject.spaceListData = [];
    });
  }

  viewAccess(collaborator) {
    this.selectedCollaborator = collaborator;
  }

  collaboratorAccessSpace(response) {
    if ($('.modal').length > 0) {
      $('.modal').modal('hide');
    }
    this.spaceListData = undefined;
    this.collaboratorAccessSpaceEmit.emit(response);
  }

  // Role status

  resetErrors() {
    this.successMsg = undefined;
    this.errorMsg = undefined;
    this.errors = [];
  }


  resendInvitation(data) {
    if (this.isSubmitted) {
      return;
    }
    this.selectedCollaborator = data;
    this.isSubmitted = true;
    const formData = {
       email: data.email
    };
    data = this.helperService.updateJsonFormat(formData);
    this.collaboratorService.resendInvitation({
      Authorization: this.accessToken,
      body: data
    }).subscribe((response: any) => {
      this.isSubmitted = false;
      this.successMsg = 'We sent a fresh invitation. Once the user sets up the account, it will be listed in the active tab.';
      setTimeout(() => {
        this.resetErrors();
      }, 5000);
   }, err => {
    this.isSubmitted = false;
    this.handleErrors(err);
   });
  }

  handleErrors(err) {
    if (err && err.error && err.error.errors && err.error.errors[0]) {
      this.errors = err.error.errors;
    } else if (err && err.error && err.error.errors && err.error.errors[0]) {
      this.errorMsg = err.error.error;
    } else {
      this.errorMsg = 'Collaborators has been already added';
    }
  }

  deleteCollaborator(response) {
    if ($('.modal').length > 0) {
      $('.modal').modal('hide');
    }
    this.selectedCollaborator = undefined;
    this.mapCollaborator(response);
    this.filteredCollaboratorsData = this.collaboratorsData;
  }

  reactivateCollaborator(response) {
    if ($('.modal').length > 0) {
      $('.modal').modal('hide');
    }
    this.selectedCollaborator = undefined;
    this.mapCollaborator(response);
    this.filteredCollaboratorsData = this.collaboratorsData;
  }

  selectCollaborator(collaborator) {
    this.selectedCollaborator = collaborator;
  }

  mapCollaborator(response) {
    this.collaboratorsData = _.map(this.collaboratorsData, (collab) => {
      if (collab.uuid === response.uuid) {
        return response;
      }
      return collab;
    });
  }
  // Role Status

  modelCloseEmit(response) {
    this.selectedCollaborator = undefined;
  }


  inviteCollaboratorsEmit(response) {
  }

  collaboratorAccessEmit(response) {
    if (this.collaboratorsData && this.selectedCollaborator) {
      this.collaboratorsData = _.map(this.collaboratorsData , (collab) => {
        if (collab.uuid === this.selectedCollaborator.uuid) {
          // Check if space array exists then map resopnse into it
          if (collab.space && collab.space.length > 0) {
            const collabSpace = collab.space;
            // If no access given to user delete collab data space
            if (response && response.role === 'noaccess') {
              collab.space = _.filter(collabSpace, (space) => {
                return space.id !== response.id;
              });
            } else {
              // Check if user has old role then map data
              const findSpace = _.find(collabSpace, {id: response.id});
              if (findSpace) {
                collab.space = _.map(collabSpace, (space) => {
                  if (response && space.id === response.id) {
                    space.role = response.role;
                  }
                  return space;
                });
              } else { // Else push new role to space of collaborator
                collab.space.push(response);
              }
            }
            return collab;
          } else {
            // If reponse is no access do nothing else push new array in collaborator space
            if (response && response.role !== 'noaccess') {
              collab.space.push(response);
            }
            return collab;
          }
        }
        return collab;
      });
      this.activeCollaborators = _.filter(this.collaboratorsData, {status: 'active'});
    }
  }


  filter(type, value) {
    if (type === 'status') {
      this.selectedStatus = value;
      if (value === '') {
        if (this.selectedRole === '') {
          this.filteredCollaboratorsData = this.collaboratorsData;
        } else {
          this.filteredCollaboratorsData = _.filter(this.collaboratorsData, {role: this.selectedRole });
        }
      } else {
        if (this.selectedRole === '') {
          this.filteredCollaboratorsData = _.filter(this.collaboratorsData, {status: value});
        } else {
          this.filteredCollaboratorsData = _.filter(this.collaboratorsData, {role: this.selectedRole, status: value });
        }
      }
    } else if (type === 'role') {
      this.selectedRole = value;
      if (value === '') {
        if (this.selectedStatus === '') {
          this.filteredCollaboratorsData = this.collaboratorsData;
        } else {
          this.filteredCollaboratorsData = _.filter(this.collaboratorsData, {status: this.selectedStatus });
        }
      } else {

        if (this.selectedStatus === '') {
          this.filteredCollaboratorsData = _.filter(this.collaboratorsData, {role: value});
        } else {
          this.filteredCollaboratorsData = _.filter(this.collaboratorsData, {role: value, status: this.selectedStatus });
        }
      }
    }

  }

}
